import { UiLogBody } from "../models/logging/UiLogBody";
import { logUnauthenticated } from "../repositories/logging";

export async function logToApi(logBody: UiLogBody | null | undefined) {
  await logUnauthenticated(logBody);
}
